export function gtag() { 
  window.dataLayer.push(arguments); 
}

export function initializeGA4( measurementId ) {
  var script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
  document.head.appendChild( script );

  window.dataLayer = window.dataLayer || [];
  
  gtag('js', new Date());
  gtag('config', measurementId );
}

export function trackPageView( pageTitle ) {
  gtag('event', 'page_view', {
    page_title: pageTitle,
    page_location: window.location.href
  });
}

export function trackLogin( method ) {
  gtag('event', 'login', {
    method: method
  })
}


// WEBPACK FOOTER //
// ./app/scripts/util/ga4.js